import type { PrescriptionPadStep } from '@/components/PatientPageV2/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updatePrescriptionPadStep: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (step: PrescriptionPadStep) => void
> = (set) => (step) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionPad.step = step;
    },
    false,
    'prescriptionPad/updatePrescriptionPadStep'
  );
